import { NavLink, Outlet } from 'react-router-dom';
import { Logo } from './Logo';
import { roleLabels } from '../types';
import { roleNavigation } from '../lib/roleNavigation';
import { useAuth } from '../state/AuthContext';

export function PortalLayout() {
  const { user, signOut, isSupabaseConfigured } = useAuth();
  if (!user) return null;

  return (
    <div className="portal-shell">
      <aside className="sidebar">
        <Logo />
        <div className="profile-chip">
          <img src="/brand/piko-parrot-mascot.png" alt="Piko parrot mascot" />
          <div>
            <strong>{user.displayName}</strong>
            <span>{roleLabels[user.role]}</span>
          </div>
        </div>
        <nav aria-label="Portal navigation">
          {roleNavigation[user.role].map((item) => (
            <NavLink key={item.path} to={item.path} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <button className="button ghost sidebar-signout" type="button" onClick={() => void signOut()}>Sign out</button>
      </aside>

      <main className="portal-main">
        <header className="portal-topbar">
          <div>
            <span className={`status-dot ${isSupabaseConfigured ? 'online' : 'demo'}`} />
            {isSupabaseConfigured ? 'Supabase connected' : 'Demo mode â€” add .env to connect'}
          </div>
          <span className="security-label">Role protected</span>
        </header>
        <Outlet />
      </main>
    </div>
  );
}


